




































































































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import AdminService from '@/services/admin.service';
import SpaceTypeService from '@/services/space-type.service';
import { AdminDto, AdminListDto, SpaceTypeDto } from '@/dto';
import { Pagination } from '@/common';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';
import { BaseUser } from '@/services/shared/auth';
import toast from '../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'AdminList',
})
export default class AdminList extends BaseComponent {
  private adminList: AdminDto[] = [];
  private adminSearchDto = new AdminListDto();
  private pagination = new Pagination();
  private adminCreateDto = new AdminDto(BaseUser);
  private adminTotalCount = null;
  private dataLoading = false;
  private spaceTypes: SpaceTypeDto[] = [];
  private searchQueryParamsDto: any = {};

  // findAll admin
  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.adminSearchDto, this.pagination);
    }
    AdminService.findAll(this.adminSearchDto, this.pagination).subscribe(
      res => {
        if (res) {
          this.dataLoading = false;
          this.adminList = res.data.items;
          this.adminTotalCount = res.data.totalCount;
        }
      },
    );
  }

  // search admin
  search() {
    this.findAll(true, true);
  }

  // pagination
  paginateSearch() {
    this.findAll(true);
  }

  // clearout search dto
  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.adminSearchDto = new AdminListDto();
      this.findAll();
    }
  }

  // get space type
  getSpaceTypes() {
    SpaceTypeService.findForSelect().subscribe(res => {
      this.spaceTypes = res.data;
    });
  }

  // create admin
  createAdmin() {
    AdminService.create(this.adminCreateDto).subscribe(res => {
      if (res) {
        toast.success('추가완료');
        this.clearOut();
      }
    });
  }

  // clearout create dto
  clearOutCreateDto() {
    this.adminCreateDto = new AdminDto(BaseUser);
    this.$bvModal.hide('add_admin');
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.adminSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getSpaceTypes();
  }
}
